import Layout from '@/layout';
export default {
  path: '/offline',
  component: Layout,
  redirect: '/offline/binding',
  name: 'Offline',
  meta: {
    title: '线下支付',
    icon: 'clipboard'
  },
  children: [{
    path: 'binding',
    component: function component() {
      return import('@/views/offline/binding/index');
    },
    name: 'Binding',
    meta: {
      title: '商户绑定'
    }
  }]
};